export const getDisplayCountOnNudgePill = (count: number) => {
  if (count < 30) {
    return '10+';
  }
  if (count < 50) {
    return '30+';
  }
  if (count < 70) {
    return '50+';
  }
  if (count < 99) {
    return '70+';
  }
  return '99+';
};
